import { Link } from 'react-router-dom';
import { featuredDramas } from '@/mocks/dramas';
import { useState, useEffect, useCallback } from 'react';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const featured = featuredDramas;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % featured.length);
  }, [featured.length]);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + featured.length) % featured.length);
  }, [featured.length]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const drama = featured[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={drama.image}
          alt={drama.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-4">
              {drama.status}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-background-50 mb-3 leading-tight">
              {drama.title}
            </h2>
            <div className="flex items-center gap-4 text-sm text-background-200 mb-4 flex-wrap">
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-accent-400"></i>
                {drama.rating}
              </span>
              <span>{drama.year}</span>
              <span>{drama.category}</span>
              <span>{drama.updateInfo}</span>
            </div>
            <p className="text-background-200 text-sm md:text-base leading-relaxed mb-6 line-clamp-2 max-w-lg">
              {drama.description}
            </p>
            <div className="flex items-center gap-3">
              <Link
                to={`/drama/${drama.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观看
              </Link>
              <Link
                to={`/category/${drama.categorySlug}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                更多{drama.category}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation arrows */}
      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {featured.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current
                ? 'bg-background-50 w-6'
                : 'bg-background-50/40 hover:bg-background-50/70'
            }`}
            aria-label={`切换至第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}